export default "__VITE_ASSET__BjT$UX9i__"